var t, e;
function i() {
  if (e) return t;
  e = 1;
  return t = class {
    constructor(t) {
      this.inputIndex = t.input_index, this.status = t.status, this.reason = t.reason, this.valid = void 0 === this.status && void 0 === this.reason, this.cities = t.city_states ? t.city_states.map(t => ({
        city: t.city,
        stateAbbreviation: t.state_abbreviation,
        state: t.state,
        mailableCity: t.mailable_city
      })) : [], this.zipcodes = t.zipcodes ? t.zipcodes.map(t => ({
        zipcode: t.zipcode,
        zipcodeType: t.zipcode_type,
        defaultCity: t.default_city,
        countyFips: t.county_fips,
        countyName: t.county_name,
        latitude: t.latitude,
        longitude: t.longitude,
        precision: t.precision,
        stateAbbreviation: t.state_abbreviation,
        state: t.state,
        alternateCounties: t.alternate_counties ? t.alternate_counties.map(t => ({
          countyFips: t.county_fips,
          countyName: t.county_name,
          stateAbbreviation: t.state_abbreviation,
          state: t.state
        })) : []
      })) : [];
    }
  };
}
export { i as __require };